export const fieldsToOmit = ['status', 'file', 'isMultiPD', 'isResolveSavePrescription'] as const;

export const contactLensesFields = {
    bc: 'None',
    color: 'None',
    color_code: 'None',
    dia: 'None',
    boxes: 0,
};
